import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';

// Type system: IBM Plex Sans (UI/body) + Archivo (display/headings) + Rajdhani (the ROLODEX wordmark).
// A deliberate, loaded pairing so the app reads as a designed product on every platform, instead of
// falling back to Inter / the system sans (the generic "template" look).
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import '@fontsource/archivo/600.css';
import '@fontsource/archivo/700.css';
import '@fontsource/archivo/800.css';
import '@fontsource/rajdhani/500.css';
import '@fontsource/rajdhani/600.css';
import '@fontsource/rajdhani/700.css';
// the Stegi theme's faces (Sofia Sans). Only the @font-face rules load here; the files are fetched
// when something renders in them.
import './styles/fonts-stegi.css';

import './styles/tokens.css';
import './styles/global.css';
import './styles/apple.css';
import './styles/settings.css';
import './styles/themes.css';

import { queryClient } from './lib/queryClient.js';
import { AuthProvider } from './auth/AuthContext.js';
import { SeasonProvider } from './season/SeasonContext.js';
import { SettingsProvider } from './settings/SettingsContext.js';
import { App } from './App.js';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SettingsProvider>
          <SeasonProvider>
            <App />
          </SeasonProvider>
        </SettingsProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
